export class GabbyUserRelationshipModel {
	link_id: number;
	name: string;
	relationship: string;
	phones: number[];
	emails: string[];
	url: string;
}
